export const AUTH_PREFIX = "@AUTH/"
export const LOGIN = `${AUTH_PREFIX}LOGIN`
export const LOGOUT = `${AUTH_PREFIX}LOGOUT`
export const REFRESH_TOKEN = `${AUTH_PREFIX}REFRESH_TOKEN`
export const FETCH_USER = `${AUTH_PREFIX}FETCH_USER`
export const REGISTER = `${AUTH_PREFIX}REGISTER`
